import { adminApi } from '@/services/backendServices/signedRequest'

export const getWebRTCStream = async (cameraDocumentId: string) => {
  return await adminApi.request({
    method: 'GET',
    url: `/live-stream/webrtc/${cameraDocumentId}`
  })
}
